export default "__VITE_ASSET__BPoYJTgE__"